import { Card, CardBody, Heading, Image, Stack, Text } from '@chakra-ui/react';
import { ICategory } from '../../interfaces';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import { CATEGORY_IMAGES_PATH } from '../../config/images';
import Colors from '../../config/colors';

interface Props {
    category: ICategory;
}

export default function Category({ category }: Props) {
    return (
        <Card
            direction={{ base: 'column' }}
            overflow="hidden"
            variant="unstyled"
            boxShadow="rgba(68, 98, 136, 0.25) 0px 3px 12px"
            borderRadius="0px"
            background={Colors.darkBlue2}
            backgroundImage={process.env.PUBLIC_URL + '/images/categories/background_spotlight.jpg'}
            backgroundSize={'cover'}
            height="270px">
            <LazyLoadImage
                src={CATEGORY_IMAGES_PATH + category.image}
                effect="blur"
                height="100%"
                style={{
                    objectFit: 'cover',
                    width: '100%',
                    position: 'relative',
                    zIndex: 1,
                    borderTopLeftRadius: '10px',
                    borderTopRightRadius: '10px',
                }}
            />

            <CardBody minH="120px" p="15px">
                <Heading size="lm" color="white" fontWeight="500">
                    {category.name}
                </Heading>
                <Text fontSize="14px" fontWeight="300" color={Colors.lightBlue}>
                    {category.description}
                </Text>
            </CardBody>
        </Card>
    );
}
